/**
 * Огонёк серии и калорий.
 *
 * viewBox обрезан ровно по рисунку (в исходном 0 0 24 24 пустого поля было
 * больше, чем самого пламени). Пустое поле слева сдвигало видимую строку
 * вправо, и выровненная по центру плашка выглядела съехавшей.
 */
export function FlameIcon({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="6.4 2.2 12.2 19.8" aria-hidden="true">
      <path
        d="M13.4 2.2c.3 2.6-.6 4.3-2 5.8-1.5 1.7-3.6 3.2-4.6 5.9-1.4 3.7.9 8.1 5.2 8.1 4 0 6.6-2.9 6.6-6.6 0-2.4-1-4-2-5.3-.4 1.1-1 1.9-1.8 2.3.5-3.6-.3-7.7-3.4-10.2Z"
        fill="currentColor"
      />
      <path
        d="M12 21.9c-2 0-3.3-1.5-3.3-3.4 0-1.8 1.2-2.7 2.1-4 .5-.7.8-1.5.8-2.4 1.6 1.2 3.6 3.2 3.6 6.1 0 2-1.3 3.7-3.2 3.7Z"
        fill="#fff"
        opacity=".5"
      />
    </svg>
  );
}
